import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, CusEcommerceMutations } from './types';

const _mutations = namespaceHelper.removeNamespace(namespace, CusEcommerceMutations);

export default {
  [_mutations.SET_PART_LIST](state, partList) {
    state.partList = partList;
  }
};
